import { getStore } from '../store/store';
import type { Calendar } from 'owa-calendar-cache';

export function getCalendars(): Calendar[] {
    return getStore().calendars;
}
